import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { Breadcrumb } from "../../../../components/breadcum";

export const SubscriptionData = () => {
    const location = useLocation();
    const params = useParams();
    const [subscriptions, setSubscriptions] = useState<any>();
    useEffect(() => {
        const data = location.pathname.includes('view');
        setSubscriptions(data);
    }, []);
    const Subscription_data = {
        data: [
            {
                created_dt: "01 Jul 2025",
                plan_amount: "₹499",
                status: "Active",
                plan_ends_dt: "01 Oct 2025"
            },
            {
                created_dt: "01 Apr 2025",
                plan_amount: "₹999",
                status: "Expired",
                plan_ends_dt: "01 Jul 2025"
            },
            {
                created_dt: "01 Jan 2025",
                plan_amount: "₹299",
                status: "Expired",
                plan_ends_dt: "01 Apr 2025"
            },
            {
                created_dt: "01 Oct 2024",
                plan_amount: "₹799",
                status: "Expired",
                plan_ends_dt: "01 Jan 2025"
            },
            {
                created_dt: "01 Jul 2024",
                plan_amount: "₹1,499",
                status: "Expired",
                plan_ends_dt: "01 Oct 2024"
            },
            {
                created_dt: "01 Apr 2024",
                plan_amount: "₹199",
                status: "Expired",
                plan_ends_dt: "01 Jul 2024"
            }
        ]
    };

    const breadcrumbInfo = [
        {
            label: "Business Units",
            value: "Business Units",
            routerLink: `/dashboard/subscriptions`,
            isActive: false,
        },
        {
            label: params.buId,
            value: params.buId,
            routerLink: ``,
            isActive: true,
        },
    ];


    return (
        <div className={subscriptions && "container-fluid content-bg-color"}>
            {subscriptions && <Breadcrumb breadCrumbList={breadcrumbInfo}></Breadcrumb>}
            <h5 className="fw-bold primary-color mt-3">Subscription Details</h5>
            {Subscription_data.data.map((value: any, index: any) => (
                <div className="card mb-2 box-shadow" key={index}>
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-3 my-1">
                                <div className="fw-bold">Start Date</div>
                                <div>{value.created_dt}</div>
                            </div>
                            <div className="col-md-3 my-1">
                                <div className="fw-bold">Amount</div>
                                <div>₹ 499</div>
                            </div>
                            <div className="col-md-3 my-1">
                                <div className="fw-bold">Expire Date</div>
                                <div>{value.plan_ends_dt}</div>
                            </div>
                            <div className="col-md-3 my-1">
                                <div className="fw-bold">Expire Date</div>
                                <div className="d-flex align-items-center">
                                    <span
                                        className="me-2"
                                        style={{
                                            width: "10px",
                                            height: "10px",
                                            background: value.status === "Active" ? "green" : value.status === "Cancelled" ? "gray" : "red",
                                            borderRadius: "50%",
                                            display: "inline-block"
                                        }}
                                    ></span>
                                    {value.status}
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    )
}